
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getBankList, delBank, setBank } from '@/api/merchant/bank'
import editBankAccount from './editBankAccount.vue'
import { statusList } from '@/utils/constant'
import { operationMessage } from '@/utils/message'
import { isShowDialog } from '@/utils/permission'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'bankAccountList',
  components: {
    editBankAccount
  }
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  get language () {
    return AppModule.language
  }
  private bankAccountList: any[] = []
  private listLoading: Boolean = false
  private statusList = statusList
  private bankAccountId: any | null = null
  private dialogVisible: boolean = false
  private action: string = ''

  private back () {
    this.$emit('close')
  }

  private closeDialog () {
    this.getBankAccountList()
  }

  // 打开窗口
  private openDialog (action: string, bankAccountId: string | null) {
    this.action = action
    this.bankAccountId = bankAccountId
    this.dialogVisible = true
  }

  private async operationCb (info: any) {
    if (info) {
      const data: any = {
        merchant_no: this.merchant_no,
        id: this.bankAccountId,
        ...info
      }
      await this.delBank(data)
    }
    this.dialogVisible = false
  }

  // 删除银行卡
  private del (id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            isShowDialog('delete_merchant_bank')
              ? this.openDialog('del', id + '')
              : this.delBank({
                  merchant_no: this.merchant_no,
                  id: this.bankAccountId
                })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            isShowDialog('delete_merchant_bank')
              ? this.openDialog('del', id + '')
              : this.delBank({
                  merchant_no: this.merchant_no,
                  id: this.bankAccountId
                })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('確定要刪除嗎？', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            isShowDialog('delete_merchant_bank')
              ? this.openDialog('del', id + '')
              : this.delBank({
                  merchant_no: this.merchant_no,
                  id: this.bankAccountId
                })
          }
        }
      })
    }
  }

  private async delBank (data: any) {
    await delBank(data).then(() => {
      operationMessage(true)
    })
  }

  private async setStatus (obj: any) {
    // 保存原来的状态
    const status = obj.status === 0 ? 1 : 0
    const data: any = {
      merchant_no: this.merchant_no,
      id: obj.id,
      status: obj.status
    }
    try {
      await setBank(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
      })
    } catch (e) {
      obj.status = status
    }
  }

  // 获取银行账户列表
  private async getBankAccountList () {
    this.listLoading = true
    try {
      await getBankList(this.merchant_no).then((res: any) => {
        this.bankAccountList = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }
  created () {
    this.getBankAccountList()
  }
}
